export default "__VITE_ASSET__Cfhf1lEP__"